const MONTH_GENITIVE: Record<string, string> = {
    январь: "января",
    февраль: "февраля",
    март: "марта",
    апрель: "апреля",
    май: "мая",
    июнь: "июня",
    июль: "июля",
    август: "августа",
    сентябрь: "сентября",
    октябрь: "октября",
    ноябрь: "ноября",
    декабрь: "декабря",
}

const MONTH_AFTER_NUMBER = new RegExp(`(\\d+\\s+)(${Object.keys(MONTH_GENITIVE).join("|")})(?![а-яё])`, "gi")

/**
 * Бэкенд присылает месяц в именительном падеже («с 9 на 10 июль»),
 * после числа он должен стоять в родительном («с 9 на 10 июля»).
 */
export function fixMonthDeclension(text: string): string {
    return text.replace(MONTH_AFTER_NUMBER, (_, prefix: string, month: string) => {
        const genitive = MONTH_GENITIVE[month.toLowerCase()]
        if (!genitive) return `${prefix}${month}`
        const isCapitalized = month.charAt(0) === month.charAt(0).toUpperCase()
        return `${prefix}${isCapitalized ? genitive.charAt(0).toUpperCase() + genitive.slice(1) : genitive}`
    })
}
